"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var AnalyticsView =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(AnalyticsView, _Record);

  function AnalyticsView() {
    (0, _classCallCheck2.default)(this, AnalyticsView);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AnalyticsView).apply(this, arguments));
  }

  return AnalyticsView;
}((0, _immutable.Record)({
  id: null,
  title: '',
  containsLegacyReportProperties: false,
  createdAt: null,
  creatorId: null,
  deletedAt: null,
  updatedDate: null,
  reportPropertyFilters: (0, _immutable.List)()
}, 'AnalyticsView'));

exports.default = AnalyticsView;
module.exports = exports.default;